import { gql, MutationHookOptions, useMutation } from "@apollo/client";

import {
  EuerDeclarationStatus,
  UpdateEuerDeclarationInput as GeneratedUpdateEuerDeclarationInput,
} from "../schema.generated";
import { EuerDeclarationFields } from "../types";

/*
 * `resetApproval` comes from the generated schema rather than being restated
 * here: it confirms that moving the declaration into "Warten auf
 * Kundenfreigabe" may reset the approval the customer gave for the previous
 * version. Without it the backend refuses that status change with
 * APPROVAL_RESET_REQUIRED. A save that leaves the status unchanged never
 * needs it.
 */
export interface UpdateEuerDeclarationInput
  extends Pick<GeneratedUpdateEuerDeclarationInput, "resetApproval"> {
  status: EuerDeclarationStatus;
  fields: EuerDeclarationFields;
}

export interface UpdateEuerDeclarationMutationVariables {
  email: string;
  year: number;
  payload: UpdateEuerDeclarationInput;
}

export interface UpdateEuerDeclarationMutationResult {
  updateEuerDeclaration: {
    status: EuerDeclarationStatus;
    statusUpdatedAt: Date;
    fields: EuerDeclarationFields;
  };
}

export const UPDATE_EUER_DECLARATION_MUTATION = gql`
  mutation updateEuerDeclaration(
    $email: String!
    $year: Int!
    $payload: UpdateEuerDeclarationInput!
  ) {
    updateEuerDeclaration(email: $email, year: $year, payload: $payload) {
      status
      statusUpdatedAt
      fields
    }
  }
`;

export const useUpdateEuerDeclarationMutation = (
  options?: MutationHookOptions<
    UpdateEuerDeclarationMutationResult,
    UpdateEuerDeclarationMutationVariables
  >
) =>
  useMutation<
    UpdateEuerDeclarationMutationResult,
    UpdateEuerDeclarationMutationVariables
  >(UPDATE_EUER_DECLARATION_MUTATION, options);
